import React from "react";
import styled from "styled-components";
import Typewriter from "typewriter-effect";
import Button from "./Button";

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  width: 100%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;
  line-height: 1.2;
  word-wrap: break-word;

  span {
    text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    color: orange;
  }
  .text-3 {
    color: red;
  }

  @media (max-width: 120em) and (min-width: 80em) {
    width: 75%;
    max-width: 450px;
  }

  @media (max-width: 80em) {
    font-size: ${(props) => props.theme.fontxl};
    width: 85%;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontlg};
    width: 90%;
  }

  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
    font-size: ${(props) => props.theme.fontmd};
    width: 95%;
  }

  @media (max-width: 30em) {
    font-size: ${(props) => props.theme.fontsm};
    width: 100%;
  }
`;

const SubTitle = styled.h3`
  font-size: ${(props) => props.theme.fontlg};
  text-transform: capitalize;
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
  font-weight: 600;
  margin-bottom: 1rem;
  width: 90%;
  align-self: flex-start;

  @media (max-width: 120em) and (min-width: 80em) {
    width: 75%;
    max-width: 450px;
  }

  @media (max-width: 80em) {
    width: 85%;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontmd};
    width: 90%;
  }

  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
    width: 95%;
  }

  @media (max-width: 30em) {
    font-size: ${(props) => props.theme.fontsm};
    width: 100%;
  }
`;

const ButtonContainer = styled.div`
  width: 90%;
  align-self: flex-start;

  @media (max-width: 120em) and (min-width: 80em) {
    width: 75%;
    max-width: 450px;
  }

  @media (max-width: 80em) {
    width: 85%;
  }

  @media (max-width: 70em) {
    width: 90%;
  }

  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
    width: 95%;

    button {
      margin: 0 auto;
    }
  }

  @media (max-width: 30em) {
    width: 100%;
  }
`;

const TypeWriterText = () => {
  return (
    <>
      <Title>
        Contributors' community on Monad
        <Typewriter
          options={{
            autoStart: true,
            loop: true,
          }}
          onInit={(typewriter) => {
            typewriter
              .typeString(`<span class="text-1">Build with Real,</span>`)
              .pauseFor(2000)
              .deleteAll()
              .typeString(`<span class="text-2">Connect with Nads.</span>`)
              .pauseFor(2000)
              // .deleteAll()
              // .typeString(`<span class="text-3">Ape Killers!</span>`)
              // .pauseFor(2000)
              .deleteAll()
              .start();
          }}
        />
      </Title>
      <SubTitle>Greal.</SubTitle>
      <ButtonContainer>
        <Button text="Explore" link="#about" />
      </ButtonContainer>
    </>
  );
};

export default TypeWriterText;
